import React, { Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import moment from 'moment';
import Auth from '../../Auth/Auth';

import './Feedback.scss';

const auth = new Auth();

function parseJwt (token) {  
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  
    return JSON.parse(jsonPayload);
  };

export default class Feedback extends Component {
    constructor(props){
        super(props);

        this.state = {
            feedbackOption : 'Problem / Complaint',
            placeholder : "Please describe your Problem / Complaint here"
        };
    }

    componentDidMount(){     
        let user = parseJwt(localStorage.getItem("msal.idtoken"));
        this.setState({
            username : user.name,
            userEmail: user.preferred_username ||  user.upn
        });
    }

    uploadImage(e){
        var self = this;
        var file = e.target.files[0];  
        var reader = new FileReader();
        reader.onload = function(event) {
            var contents = event.target.result;
            var fileName = file.name;

            self.setState({
                screenshotName : fileName,
                screenshot : contents
            });
        };

        reader.onerror = function(event) {
            console.error("File could not be read! Code " + event.target.error.code);
        };

        reader.readAsDataURL(file);
    }

    feedbackOption(Option){
        let placeholder;
        switch(Option){
            case "Problem / Complaint" : placeholder = "Please describe your Problem / Complaint here";
            break;

            case "Question" : placeholder =  "Please ask your Question here";
            break;

            case "Idea / Suggestion" : placeholder =  "We love Ideas and Suggestions, let us know yours here";
            break;

            case "Appreciate" : placeholder =  "Like the new Fetch? Let us know here";
            break;

            default : placeholder =  "Please describe your issue here";

            return placeholder;
        }

        this.setState({
            feedbackOption : Option,
            placeholder : placeholder
        });
    }

    handleChange(e){
        this.setState({
            [e.target.name] : e.target.value,
        });
       
    }

    async submitFeedback(){
    let accessToken = await auth.getToken();
    let jwt = parseJwt(localStorage.getItem("msal.idtoken"));
        
    let feedback = {
        username : this.state.username,
        userEmail : this.state.userEmail,
        feedbackOption : this.state.feedbackOption,
        feedback : this.state.feedback,
        feedbackImageName : this.state.screenshotName,
        feedbackImage : this.state.screenshot,
        lastSearch: this.props.mainSearch
    };

    fetch(`/api/userfeedback`,{
        method : "POST",
        headers : {
            "Content-Type": "application/json",
            "loggedinclient" : jwt.oid,
            'Authorization': "Bearer " + accessToken,
            withCredentials : true,
            crossDomain: true,
        },
        body: JSON.stringify(feedback)
        }).then(response => {
            if(response.status!==200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        })
        .then(success => {
            this.props.closeModal();
        }).catch((err) => {
            window.apiError(err);
        });
    }

    render(){
        return (
            <Row className="feedback-content" >
                <Col lg={{ span : 12}}>     
                    <h6 className="mt-4 header">Send Feedback</h6> 
                    <hr />
                    <p>{this.state.username}</p>   
                    <p className="small">{this.state.userEmail}</p>  
                    <p className="small">{moment().format('MMM DD YYYY')}</p>    
                    <Row className="feedback-container">
                        {['Problem / Complaint','Question','Idea / Suggestion','Appreciate'].map((items,index) => 
                            <Col key={index} onClick={() => this.feedbackOption(items)} lg={{span : 3}} className="feedback-options">
                                <p className={this.state.feedbackOption === items ? "active" : ""}>{items}</p>
                            </Col>
                        )}
                        <Col lg={{span : 12}}>
                            <hr />
                        </Col>                        
                        <Col lg={{span : 12}}>
                            <textarea name="feedback" onChange={(e) => this.handleChange(e) } className="feedback-text" rows="10" placeholder={this.state.placeholder}>
                            </textarea>
                        </Col> 
                          
                        <Col>
                            <Button variant="link" onClick={(e) => this.refs.ImageUpload.click()}><i className="fa fa-camera mr-2" aria-hidden="true"></i>  Attach image</Button>
                            <input type="file" ref="ImageUpload" onChange={(e) => this.uploadImage(e)} hidden/>
                            <p className="pl-2 mb-3"><small>*To upload multiple images just throw them in a word document and upload above</small></p>
                            {this.state.screenshotName && (
                                <ul className="mb-0">
                                    <li>{this.state.screenshotName}</li>
                                </ul>
                            )}                                                        
                            
                        </Col>                     
                    </Row>  
                    <Row>
                        <Col className="text-right">
                            <Button onClick={() => this.props.closeModal()} variant="link">Cancel</Button>
                            <Button onClick={() => this.submitFeedback()}>Send</Button>
                        </Col>
                    </Row>       
                </Col>
            </Row>       
       );
    }
}

